import mapValues from 'lodash/mapValues';
import isArray from 'lodash/isArray';
import isString from 'lodash/isString';
import isEmpty from 'lodash/isEmpty';
import toString from 'lodash/toString';
import toNumber from 'lodash/toNumber';
import includes from 'lodash/includes';
import moment from 'moment';
import capitalize from 'lodash/capitalize';
import replace from 'lodash/replace';
import cloneDeep from 'lodash/cloneDeep';
import { isNil, pick } from 'lodash';
import {
  approveAudit,
  approveObjection,
  rejectAudit,
  rejectObjection,
  approveAuditorApplication,
  rejectAuditorApplication,
  finalApproveCommitteeApplication,
  withdrawCommitteeApplication,
} from 'store/forms/actions';
import { printInfo } from 'store/forms/utils';
import {
  carrierKeys,
  documentKeys,
  mapBankOptionsValueToId,
} from 'store/utils';
import { debounce } from 'lodash';
import { isExpiredDate } from './helpers';
import { addComment } from 'store/appTrack/actions';

export const logoutUrl = `${window.location.protocol}//${window.location.hostname}${process.env.REACT_APP_BACKEND_HOST_PORT}/${process.env.REACT_APP_FLOWABLE_CONTEXT_PATH}/exit`;
export const redirectUrl = `${window.location.protocol}//${window.location.hostname}${process.env.REACT_APP_APPTRACK_PORT}/${process.env.REACT_APP_FLOWABLE_CONTEXT_PATH}/workflow/appTrack`;
export const mainFormsUrl = task => {
  return `${window.location.protocol}//${window.location.hostname}${process.env.REACT_APP_BACKEND_HOST_PORT}/${process.env.REACT_APP_FLOWABLE_CONTEXT_PATH}/workflow/forms/task/${task}`;
};
export const viewUrl = task => {
  return `${window.location.protocol}//${window.location.hostname}${process.env.REACT_APP_BACKEND_HOST_PORT}/${process.env.REACT_APP_FLOWABLE_CONTEXT_PATH}/appTrack#/view/${task}`;
};

export const dateFormat = 'DD/MM/YYYY';

export const getFullDate = date => {
  if (typeof date === 'undefined') {
    return '-';
  } else {
    const dateAndTime = date.split('T');

    return dateAndTime[0];
  }
};

export const isInvestor = privileges =>
  !isEmpty(privileges) && privileges.includes('isBeneficiary');
export const isBeneficiary = groups =>
  !isEmpty(groups) && groups.some(group => includes(group.id, 'Beneficiary'));
export const isSubmitter = privileges =>
  !isEmpty(privileges) && privileges.includes('isCommittee');
export const isObjectionCommittee = privileges =>
  !isEmpty(privileges) && privileges.includes('isObjectionCommittee');
export const isAuditor = groups =>
  !isEmpty(groups) && groups.some(group => includes(group.id, 'AUDITOR'));
export const isCommittee = groups =>
  !isEmpty(groups) && groups.some(group => includes(group.id, 'COMMITTEE'));
export const isEditor = groups =>
  !isEmpty(groups) && groups.some(group => includes(group.id, 'EDITOR'));
export const isKtP = groups =>
  !isEmpty(groups) && groups.some(group => group.id === 'KTP');
export const isMinistry = groups =>
  !isEmpty(groups) && groups.some(group => group.id === 'Ministry');
export const isProvider = groups =>
  !isEmpty(groups) &&
  groups.some(group => group.id === 'ProviderResourceGroup');
export const isAdminUser = groups =>
  !isEmpty(groups) && groups.some(group => group.id === 'AdminResourceGroup');
export const isUserAbleToSubmit = (formKey, groups) =>
  isInvestor(groups) ||
  (!isInvestor(groups) &&
    (isSubmitter(groups) || !(isEditor(groups) && !isSubmitter(groups))));

export const outcomes = {
  saveInvestor: 'Αποθήκευση',
  submitNP: 'submission',
  rejectKtp: 'reject',
  approveKtp: 'accept',
  redeemProvider: 'reedeem',
  cancelBeneficiary: 'cancel',
  returnAuditor: 'return',
};

export const companyLegalTypeList = [
  { label: 'Άτομική', value: 'Άτομική' },
  { label: 'Ομόρρυθμη Εταιρεία', value: 'Ομόρρυθμη Εταιρεία' },
  { label: 'Ετερόρρυθμη Εταιρεία', value: 'Ετερόρρυθμη Εταιρεία' },
  {
    label: 'Εταιρεία Περιορισμένης Ευθύνης',
    value: 'Εταιρεία Περιορισμένης Ευθύνης',
  },
  {
    label: 'Ιδιωτική Κεφαλαιουχική Εταιρεία',
    value: 'Ιδιωτική Κεφαλαιουχική Εταιρεία',
  },
  { label: 'Ανώνυμη Εταιρεία', value: 'Ανώνυμη Εταιρεία' },
  {
    label: 'Κοινωνική Συνεταιριστική Επιχείρηση',
    value: 'Κοινωνική Συνεταιριστική Επιχείρηση',
  },
  { label: 'Άλλο', value: 'Άλλο' },
];

export const paymentMeanOptions = [
  { label: 'Τοις μετρητοίς ', value: 'Τοις μετρητοίς ' },
  { label: 'Με πιστωτική κάρτα', value: 'Με πιστωτική κάρτα' },
  { label: 'Κατάθεση σε λογαριασμό', value: 'Κατάθεση σε λογαριασμό' },
  {
    label: 'Επί αποδόση',
    value: 'Επί αποδόση',
  },
];

export const rcptTypeOptions = [
  { label: 'Απόδειξη', value: 'Απόδειξη' },
  { label: 'Τιμολόγιο', value: 'Τιμολόγιο' },
  { label: 'Άλλο', value: 'Άλλο' },
];

export const euroFormatter = new Intl.NumberFormat('el-GR', {
  style: 'currency',
  currency: 'EUR',
  minimumFractionDigits: 2,
});

export const renderCurrency = value => {
  return Number.isNaN(parseFloat(printInfo(value)))
    ? '-'
    : euroFormatter.format(printInfo(value));
};

export const handleSave = ({
  state,
  dispatch,
  saveTask,
  taskId,
  formId,
  isSaved,
  activeFormId = null,
}) => {
  const normalizedIban = state.carrier.iban?.replace(/\s+/g, '').toUpperCase();
  const hasAlreadySavedBnkName = !!state.carrier.bnkName;
  const hasAlreadySavedIban =
    !!normalizedIban && /^GR\d{25}$/.test(normalizedIban);
  const carrier = {
    ...state.carrier,
    bnk: !!state.carrier.bnkName
      ? mapBankOptionsValueToId(state.carrier.bnkName)
      : null,
    hasAlreadySavedIban: hasAlreadySavedIban,
    hasAlreadySavedBnkName: hasAlreadySavedBnkName,
    hasAddedIbanAndBank: hasAlreadySavedBnkName && hasAlreadySavedIban,
  };
  const documents = { ...state.documents };
  const terms = { ...state.terms };

  const parsedDocs = mapValues(
    documents,
    doc =>
      isArray(doc) // case of multiple documents (array of objects)
        ? toString(doc.map(d => d.id))
        : !isNil(doc) && isString(doc) // case of radio buttons inside document form
        ? doc
        : !isNil(doc)
        ? doc.id
        : '' // case of single documents (object)
  );

  const payload = {
    values: {
      ...documents,
      // ...pick(parsedDocs, documentKeys(parsedDocs)),
      ...pick(carrier, carrierKeys(carrier)),
      ...terms,
      isSaved,
    },
    formId,
    taskId,
  };

  /**
   * *** BEGIN::Add comment for inserting bank and iban all together ***
   */
  const previouslyAddedIbanAndBank = !!state.carrier.hasAddedIbanAndBank;
  const correctlyAddedBothIbanAndBankNow =
    hasAlreadySavedBnkName &&
    hasAlreadySavedIban &&
    !previouslyAddedIbanAndBank;
  if (correctlyAddedBothIbanAndBankNow) {
    if (activeFormId && state.businessKey) {
      const comment = `Για την αίτηση ${state.businessKey} έχει δηλωθεί ${state.carrier.bnkName} και ${normalizedIban}`;
      dispatch(addComment(activeFormId, comment));
    }
  }
  /**
   * *** END::Add comment for inserting bank and iban all together ***
   */

  // console.log({parsedDocs});
  // console.log({payload});
  dispatch(saveTask(payload));
};

export const handleSubmit = ({
  state,
  user,
  dispatch,
  submitTask,
  rejectTask,
  navigate,
  setIsVisible,
  taskId,
  formId,
  formKey,
  outcome,
  // reject,
  returnState,
  setInvalidSubModalVisible,
  task,
}) => {
  const normalizedIban = state.carrier.iban?.replace(/\s+/g, '').toUpperCase();
  const carrier = {
    ...state.carrier,
    bnk: !!state.carrier.bnkName
      ? mapBankOptionsValueToId(state.carrier.bnkName)
      : null,
    hasAlreadySavedIban: !!normalizedIban && /^GR\d{25}$/.test(normalizedIban),
    hasAlreadySavedBnkName: !!state.carrier.bnkName,
  };
  const documents = { ...state.documents };
  const terms = { ...state.terms };
  // const reject = state?.reject;
  const isSaved = true;
  const isUserKTP =
    user.groups?.filter(a => a.id.startsWith('KTP')).length > 0
      ? user.groups?.filter(a => a.id.startsWith('KTP')).length > 0
      : false;
  // Document payload should be string of id for single items (e.g. ibaStockRev: '32432fdw34') and string of csv ids for multiple items (e.g. ibaStockRev: '83293few2342,3943fe234,2131hfe3')
  const parsedDocs = mapValues(
    documents,
    doc =>
      isArray(doc) // case of multiple documents (array of objects)
        ? toString(doc.map(d => d.id))
        : !isNil(doc) && isString(doc) // case of radio buttons inside document form
        ? doc
        : !isNil(doc)
        ? doc.id
        : '' // case of single documents (object)
  );

  let payload = isUserKTP
    ? {
        task,
        // formId,
        taskId,
        navigate,
        values: {
          isSaved,
          flow_audit_outcome: outcome,
          ...pick(carrier, carrierKeys(carrier)),
          // ...parsedDocs,
          ...terms,
          ...pick(documents, documentKeys(documents)),
        },
      }
    : {
        task,
        // formId,
        taskId,
        navigate,
        values: {
          isSaved,
          flow_outcome_submit_application: outcome,
          ...pick(carrier, carrierKeys(carrier)),
          // ...pick(parsedDocs, documentKeys(parsedDocs)),
          ...terms,
          ...pick(documents, documentKeys(documents)),
        },
      };

  // console.log({payload})
  dispatch(submitTask(payload));
};

export const handleReturn = ({
  state,
  dispatch,
  rejectTask,
  approveAudit,
  rejectAudit,
  taskId,
  formId,
  formKey,
  outcome,
}) => {
  handleSubmit({
    state,
    dispatch,
    rejectTask,
    taskId,
    formId,
    formKey,
    outcome,
  });
};

// Required fields for Documents
export const isDocumentNPValid = (user, documents) => {
  if (
    isBeneficiary(user?.groups) &&
    documents?.benApplAuthor && //1. Εξουσιοδότηση Αίτησης Ένταξης
    documents?.benPropStatus && //2. Έγγραφα Ιδιοκτησιακού Καθεστώτος
    documents?.benBuildLegal && //3. Νομιμοποιητικά Έγγραφα Κτιρίου/ων
    documents?.benRespDeclar && //5. Υπεύθυνη Δήλωση Μη Ριζικής Ανακαίνισης
    documents?.benPrimEarth && //6. Δελτίο Πρωτοβάθμιου Προσεισμικού Ελέγχου
    documents?.benTechStudy && //7. Τεχνική Μελέτη
    documents?.benCompSub && //8. Τεκμηρίωση Αρμοδιότητας Υποβολής Αίτησης Ένταξης
    documents?.benDecision && //9. Απόφαση Υποψηφίου Δικαιούχου Αίτησης Ένταξης
    documents?.benSeak && //10. ΣΕΑΚ
    documents?.benFirstPea && //11. 1ο Πιστοποιητικό Ενεργειακής Απόδοσης
    documents?.prclNumber && //Αρ. Πρωτοκόλλου ΠΕΑ
    documents?.secCode && //Κωδικός Ασφαλείας ΠΕΑ
    documents?.certificationYear //Έτος ΠΕΑ
  ) {
    return true;
  }
  return false;
};

export const isDocumentAudValid = (user, documents) => {
  if (
    isAuditor(user?.groups) &&
    documents?.audDocsCompletenessReport && //Έκθεση πληρότητας Δικαιολογητικών
    documents?.audInvestmentPlanCompletenessReport //Έκθεση Πληρότητας Επενδυτικού Σχεδίου
  ) {
    return true;
  }
  return false;
};

export const isExpensesValid = businessPlanDetails => {
  let assets = businessPlanDetails?.businessPlanAssets;

  return assets
    ?.map(i => {
      return i.activityCode ==
        'Προμήθεια και Εγκατάσταση Συστήματος Αποθήκευσης & των Παρελκόμενων (Πίνακες, Καλώδια, Έξυπνοι Μετρητές κλπ). Μπαταρία Χωρητικότητας 1h' ||
        i.activityCode ==
          'Προμήθεια και Εγκατάσταση Συστήματος Αποθήκευσης & των Παρελκόμενων (Πίνακες, Καλώδια, Έξυπνοι Μετρητές κλπ). Μπαταρία Χωρητικότητας 1h έως 2h'
        ? true
        : false;
    })
    .includes(true);
};

export const isBusPlanDescValid = busPlanDesc => {
  if (
    busPlanDesc?.abiBpTitle &&
    validDateStart(busPlanDesc?.abiInvStartDt) &&
    busPlanDesc?.abiInvEndDt &&
    validateMonth(busPlanDesc?.abiMonths) &&
    busPlanDesc?.abiShorexpensessc &&
    busPlanDesc?.abiInvLoc &&
    busPlanDesc?.invAddressLoc &&
    busPlanDesc?.invTkLoc &&
    busPlanDesc?.invPerfectureLoc &&
    busPlanDesc?.abiMonths < 25 &&
    busPlanDesc?.invDistrict
  ) {
    return true;
  }
  return false;
};

// Required fields for Carrier
export const isCarrierNPValid = carrier => {
  if (
    //1.1 Στοιχεία Επιχείρησης
    carrier?.companyName &&
    validAFM(carrier?.abiVat) &&
    // carrier?.mainKAD &&
    // carrier?.regDate &&
    // //Διεύθυνση Έδρας Επιχείρησης
    carrier?.abiStreetFull &&
    carrier?.abiTk &&
    carrier?.abiPerfecture &&
    carrier?.abiDistrict &&
    validEmail(carrier?.invMail) &&
    //Στοιχεία Κτιρίου
    carrier?.schoolGrade &&
    carrier?.coHousing !== undefined &&
    (carrier?.coHousing
      ? carrier?.schoolGradeCo && carrier?.coHousingName
      : true) &&
    carrier?.buildName &&
    carrier?.buildUsage &&
    carrier?.buildYear &&
    carrier?.buildStreet &&
    carrier?.buildTk &&
    carrier?.buildPerfecture &&
    carrier?.buildDistrict &&
    carrier?.powerSupNo &&
    carrier?.usableArea &&
    carrier?.totalArea &&
    carrier?.degDays &&
    //Δαπάνες
    (carrier?.thermIns ||
      carrier?.shellReplace ||
      carrier?.upgradeSys ||
      carrier?.otherServices) &&
    (carrier?.thermIns
      ? carrier?.amountThermIns &&
        carrier?.amountThermIns !== '0,00' &&
        carrier?.amountThermInsFpa
      : true) &&
    (carrier?.shellReplace
      ? carrier?.amountShellReplace &&
        carrier?.amountShellReplace !== '0,00' &&
        carrier?.amountShellReplaceFpa
      : true) &&
    (carrier?.upgradeSys
      ? carrier?.amountUpgradeSys &&
        carrier?.amountUpgradeSys !== '0,00' &&
        carrier?.amountUpgradeSysFpa
      : true) &&
    (carrier?.otherServices
      ? carrier?.amountOtherServices &&
        carrier?.amountOtherServices !== '0,00' &&
        carrier?.amountOtherServicesFpa
      : true)
  ) {
    //1.2
    if (carrier.contactPersonFlag === false) {
      if (
        !(
          carrier?.contactSurname &&
          carrier?.contactName &&
          carrier?.contactVat &&
          validPhoneNumber(carrier?.contactPhone, true) &&
          validEmail(carrier?.contactEmail)
        )
      ) {
        return false;
      }
    }
    if (
      !(
        carrier?.legalSurname &&
        carrier?.legalName &&
        validAFM(carrier?.legalVat) &&
        validPhoneNumber(carrier?.legalPhone, true) &&
        validEmail(carrier?.legalEmail)
      )
    ) {
      return false;
    }

    return true;
  }
  return false;
};

export const isCarrierAudValid = carrier => {
  if (
    //1.1 Στοιχεία Επιχείρησης
    carrier?.amountInvestmentPlan &&
    carrier?.reductionForecast &&
    carrier?.indicator &&
    carrier?.evaluationCheck
  ) {
    return true;
  }
  return false;
};

// 1.3 Στοιχεία Εταιρικής Σύνθεσης Ωφελούμενου
export const isCarrierShareHolders = carrier => {
  if (
    carrier.otherShareholdersFlag &&
    carrier.otherShareholdersFlag === 'Ναι'
  ) {
    var flag = false;
    var i = 0;

    for (i in carrier.carrierShareHolders) {
      flag = false;

      if (carrier?.carrierShareHolders[i].shareHolderName == '') {
        return (flag = false);
      } else if (
        carrier?.carrierShareHolders[i].shareHolderVat == '' ||
        !validAFM(carrier?.carrierShareHolders[i].shareHolderVat)
      ) {
        return (flag = false);
      } else if (carrier?.carrierShareHolders[i].shareHolderCountry == '') {
        return (flag = false);
      }

      if (carrier.carrierShareHolders.hasOwnProperty(i)) {
        if (
          carrier?.carrierShareHolders[i].shareHolderName !== null &&
          carrier?.carrierShareHolders[i].shareHolderVat !== null &&
          carrier?.carrierShareHolders[i].shareHolderCountry !== null &&
          carrier?.carrierShareHolders[i].percentage !== null &&
          typeof carrier?.carrierShareHolders[i].percentage !== 'undefined' &&
          carrier?.sumCheckShareHolders <= 100
        ) {
          if (
            parseFloat(
              carrier?.carrierShareHolders[i].percentage.replace(',', '.')
            ) > 0
          ) {
            flag = true;
          } else {
            return (flag = false);
          }
        } else {
          return (flag = false);
        }
      } else {
        flag = false;
      }
      i++;
    }

    return flag;
  }

  return true;
};

export const isCarrierShareHolders2 = carrier => {
  if (
    carrier.otherShareholdersFlag2 &&
    carrier.otherShareholdersFlag2 != 'Όχι'
  ) {
    var flag = false;
    var i = 0;

    for (i in carrier.carrierShareHolders2) {
      flag = false;

      if (carrier?.carrierShareHolders2[i].partName == '') {
        return (flag = false);
      } else if (
        carrier?.carrierShareHolders2[i].partVat == '' ||
        !validAFM(carrier?.carrierShareHolders2[i].partVat)
      ) {
        return (flag = false);
      } else if (
        carrier?.carrierShareHolders2[i].partEstablishment == '' ||
        !validYear(carrier?.carrierShareHolders2[i].partEstablishment)
      ) {
        return (flag = false);
      } else if (carrier?.carrierShareHolders2[i].partKAD == '') {
        return (flag = false);
      }

      if (carrier.carrierShareHolders2.hasOwnProperty(i)) {
        if (
          carrier?.carrierShareHolders2[i].partName !== null &&
          carrier?.carrierShareHolders2[i].partVat !== null &&
          carrier?.carrierShareHolders2[i].partEstablishment !== null &&
          carrier?.carrierShareHolders2[i].partKAD !== null &&
          carrier?.carrierShareHolders2[i].partPercentage !== null &&
          typeof carrier?.carrierShareHolders2[i].partPercentage !== 'undefined'
        ) {
          if (
            parseFloat(
              carrier?.carrierShareHolders2[i].partPercentage.replace(',', '.')
            ) > 0
          ) {
            flag = true;
          } else {
            return (flag = false);
          }
        } else {
          return (flag = false);
        }
      } else {
        flag = false;
      }
      i++;
    }

    return flag;
  }

  return true;
};

export const isSingleCompany = carrier => {
  if (carrier.singleCompanyFlag && carrier.singleCompanyFlag != 'Όχι') {
    var flag = false;
    var i = 0;

    for (i in carrier.singleCompanies) {
      flag = false;

      if (carrier?.singleCompanies[i].singleCompanyName == '') {
        return (flag = false);
      } else if (
        carrier?.singleCompanies[i].singleCompanyVat == '' ||
        !validAFM(carrier?.singleCompanies[i].singleCompanyVat)
      ) {
        return (flag = false);
      }

      if (carrier.singleCompanies.hasOwnProperty(i)) {
        if (
          carrier?.singleCompanies[i].singleCompanyName !== null &&
          carrier?.singleCompanies[i].singleCompanyVat !== null
        ) {
          flag = true;
        } else {
          return (flag = false);
        }
      } else {
        flag = false;
      }
      i++;
    }

    return flag;
  }

  return true;
};

export const isCarrierConnectionDetails = carrier => {
  var flag = false;
  var i = 0;

  for (i in carrier.connectionDetails) {
    flag = false;

    if (carrier?.connectionDetails[i].supplyNum == '') {
      return (flag = false);
    } else if (carrier?.connectionDetails[i].supAddress == '') {
      return (flag = false);
    } else if (carrier?.connectionDetails[i].storageCap == '') {
      return (flag = false);
    } else if (carrier?.connectionDetails[i].supplyPower == '') {
      return (flag = false);
    }
    if (carrier.connectionDetails.hasOwnProperty(i)) {
      if (
        carrier?.connectionDetails[i].supplyNum !== null &&
        carrier?.connectionDetails[i].supAddress !== null &&
        carrier?.connectionDetails[i].storageCap !== null &&
        carrier?.connectionDetails[i].supplyPower !== null
      ) {
        flag = true;
      } else {
        return (flag = false);
      }
    } else {
      flag = false;
    }
    i++;
  }

  return flag;
};

export const isRejectedValid = carrier => {
  if (
    (carrier?.objectionFieldType && carrier?.objectionOption5) ||
    carrier?.objectionOption4 ||
    carrier?.objectionOption3 ||
    carrier?.objectionOption2 ||
    carrier?.objectionOption1
  ) {
    return false;
  } else {
    return true;
  }
};

export const isTermsNPValid = terms => {
  if (
    //tab Τήρηση Προϋποθέσεων Συμμετοχής
    terms?.terms1 &&
    terms?.terms2 &&
    terms?.terms3 &&
    terms?.terms4 &&
    terms?.terms5 &&
    terms?.terms6 &&
    terms?.terms7 &&
    terms?.terms8 &&
    terms?.terms9 &&
    terms?.terms10 &&
    terms?.terms11 &&
    terms?.terms12
  ) {
    return true;
  }
  return false;
};

export const isTermsFPValid = terms => {
  if (
    //tab Τήρηση Προϋποθέσεων Συμμετοχής
    terms?.terms1 &&
    terms?.terms2 &&
    terms?.terms3 &&
    terms?.terms4 &&
    terms?.terms5
  ) {
    return true;
  }
  return false;
};

export const isInvestorObjectionFinalCommentValid = compliance => {
  let valid = false;

  if (compliance?.objInvFinalComment) {
    valid = true;
  }

  return valid;
};

export const isInvestorObjectionReasonsValid = compliance => {
  let valid = false;

  if (compliance?.objInvOtherFlag && compliance.objInvOtherFlag == true) {
    if (compliance?.objInvOtheFlagComment) {
      valid = true;
    }
  } else if (
    compliance?.objInvNoSubmitPEA &&
    compliance.objInvNoSubmitPEA == true
  ) {
    valid = true;
  }

  return valid;
};

export const isCarrierUsersValid = carrier => {
  return !isNil(carrier.carrierUsers)
    ? // carrier.carrierUsers.every(el =>
      //   ((isNil(el.userLName) || el.userLName=="") && (isNil(el.userFName)||el.userFName=="")
      //   && (isNil(el.userFathName)||el.userFathName=="") && (isNil(el.userVat)|| el.userVat=="")
      //   && (isNil(el.userPhone)||el.userPhone=="") && (isNil(el.userEmail)||el.userEmail=="") )) ? true :

      carrier.carrierUsers.every(
        el =>
          !isNil(el.userLName) &&
          el.userLName !== '' &&
          !isNil(el.userFName) &&
          el.userFName !== '' &&
          !isNil(el.userFathName) &&
          el.userFathName !== '' &&
          !isNil(el.userVat) &&
          el.userVat !== '' &&
          !isNil(el.userPhone) &&
          el.userPhone !== '' &&
          !isNil(el.userEmail) &&
          el.userEmail !== ''
      )
    : true;
};

// Required fields for Bank
// export const isBankValid = (bank, formKey) => {
//   const confirmed = bank.ibanValidation  ? bank.ibanValidation.confirmAccountOutputRecord?.confirmed ? bank.ibanValidation.confirmAccountOutputRecord.confirmed : '0' : '0'
//   const usageAllowed = bank.ibanValidation ? bank.ibanValidation.confirmAccountOutputRecord?.usageAllowed ? bank.ibanValidation.confirmAccountOutputRecord.usageAllowed : '0' : '0'
//   const total =
//     bank.hasOwnProperty('bnkSyndLoan') && bank.bnkSyndLoan === 'Ναι'
//       ? // on some occasions, even when the bank percentages do not have mantissa, their sum is 0.99999999 which does
//         // not pass validation, so we do rounding on the 4th digit
//         Math.round(totalCount(bank.bnkClbBanks) * 10000) / 10000
//       : 1;

//   if (bank.showBankTab && formKey && total === 1) return true;
//   if (bank?.bnkBank && !formKey && bank?.beneficiaryIban && bank?.beneficiaryIban.length === 27  && bank?.ibanValidation && bank?.ibanValidation.taxisValidation === true) {
//     return true;
//   }
//   return false;
// };

// Required fields for Buisiness Plan
export const isBusinessPlanValid = businessPlan => {
  let valid = true;
  let busAssets = businessPlan?.businessPlanAssets;
  let expenses = businessPlan?.businessPlanAssets?.expenses;

  let businessPlanAssets = !isNil(busAssets?.processInstanceId)
    ? expenses
    : busAssets;

  //validate assets
  if (businessPlanAssets) {
    if (businessPlanAssets.length >= 1) {
      businessPlanAssets.map(item => {
        if (
          item.activityCode == null ||
          isEmpty(item.expDesc) ||
          item.quantity == null
        ) {
          valid = false;
        }
      });

      let findAntlies = businessPlanAssets.find(
        asset => asset.activityCode == 'Αντλίες Θερμότητας'
      );
      if (findAntlies == undefined) valid = false;
    }
  } else {
    valid = false;
  }

  return valid;
};

export const isComplianceValid = compliance => {
  let valid = false;

  if (
    compliance?.esgFlag &&
    compliance.esgFlag == true &&
    compliance?.bankruptcyFlag &&
    compliance.bankruptcyFlag == true &&
    compliance?.rescueGrantFlag &&
    compliance.rescueGrantFlag == true &&
    compliance?.penaltyFlag &&
    compliance.penaltyFlag == true &&
    compliance?.initiationFlag &&
    compliance.initiationFlag == true &&
    compliance?.uniqFlag &&
    compliance.uniqFlag == true &&
    compliance?.confirmFlag &&
    compliance.confirmFlag == true &&
    compliance?.gdprFlag &&
    compliance.gdprFlag == true &&
    compliance?.communicationFlag &&
    compliance.communicationFlag == true &&
    compliance?.kef1Flag &&
    compliance.kef1Flag == true &&
    compliance?.IlligFlag &&
    compliance.IlligFlag == true &&
    compliance?.ProblFlag &&
    compliance.ProblFlag == true &&
    compliance?.DeptFlag &&
    compliance.DeptFlag == true &&
    compliance?.TechnFlag &&
    compliance.TechnFlag == true &&
    compliance?.SDateFlag &&
    compliance.SDateFlag == true &&
    compliance?.ElemFlag &&
    compliance.ElemFlag == true &&
    compliance?.PublFlag &&
    compliance.PublFlag == true &&
    compliance?.PropFlag &&
    compliance.PropFlag == true &&
    compliance?.BankAccntFlag &&
    compliance.BankAccntFlag == true &&
    compliance?.govSupFlag
  ) {
    valid = true;
  }

  return valid;
};

// Required fields for Loan Review
export const isLoanReviewValid = loanReview => {
  if (
    valueValid(loanReview?.rlcLnAmnt, 999999999) &&
    percentageValid(loanReview?.rlcLnInter) &&
    loanReview?.lrcAudCkl1 &&
    loanReview?.lrcAudCkl2 &&
    loanReview?.lrcAudCkl3
    // loanReview?.lrcAudCkl4 &&
    // loanReview?.lrcAudCkl5 &&
    // loanReview?.lrcAudCkl6
  ) {
    return true;
  }
  return false;
};

// Required fields for Conflicts
export const isConflictsValid = conflicts => {
  if (conflicts?.agdAdvContDt) {
    return true;
  }
  return false;
};

export const auditorOutcomes = {
  approveAuditor: 'approveAuditor',
  rejectAuditor: 'rejectAuditor',
};

export const committeeOutcomes = {
  finalApproveCommittee: 'finalApproveCommittee',
  withdrawCommittee: 'withdrawCommittee',
};

export const handleAuditorSubmit = async ({
  outcome,
  dispatch,
  procInstId,
  navigate,
  rejectAuditorReason,
  rejectAuditorMessage,
}) => {
  try {
    // params san ton KTP user
    const params = {
      procInstId,
      navigate,
      rejectAuditorReason,
      rejectAuditorMessage,
    };

    if (outcome === auditorOutcomes.approveAuditor) {
      await dispatch(approveAuditorApplication(params));
    } else if (outcome === auditorOutcomes.rejectAuditor) {
      await dispatch(rejectAuditorApplication(params));
    }
  } catch (error) {
    console.error('Error in auditor submission:', error);
  }
};

export const handleCommitteeSubmit = async ({
  outcome,
  dispatch,
  procInstId,
  navigate,
  withdrawCommitteeReason,
  withdrawCommitteeMessage,
}) => {
  try {
    // params san ton KTP user
    const params = {
      procInstId,
      navigate,
      withdrawCommitteeReason,
      withdrawCommitteeMessage,
    };

    if (outcome === committeeOutcomes.finalApproveCommittee) {
      await dispatch(finalApproveCommitteeApplication(params));
    } else if (outcome === committeeOutcomes.withdrawCommittee) {
      await dispatch(withdrawCommitteeApplication(params));
    }
  } catch (error) {
    console.error('Error in committee submission:', error);
  }
};

export const handleSubmitDisabled = ({ user, state, formKey }) => {
  if (process.env.REACT_APP_VALIDATIONS == 'true') {
    return false;
  }
  const { carrier, documents, businessPlanDetails, terms } = state;

  if (isBeneficiary(user?.groups)) {
    console.log(
      '\n',
      '\n',
      'isBeneficiary',
      '\n',
      'isCarrierNPValid: ',
      isCarrierNPValid(carrier),
      '\n',
      'isTermsValid: ',
      isTermsNPValid(terms, carrier),
      '\n',
      'isDocumentNPValid: ',
      isDocumentNPValid(user, documents, carrier.schoolGrade)
    );
  }

  if (isAuditor(user?.groups)) {
    console.log(
      '\n',
      '\n',
      'isAuditor',
      '\n',
      'isCarrierAudValid: ',
      isCarrierAudValid(carrier),
      '\n',
      'isDocumentNPValid: ',
      isDocumentAudValid(user, documents)
    );
  }

  if (
    //Beneficiary
    isBeneficiary(user?.groups) &&
    isCarrierNPValid(carrier) &&
    isDocumentNPValid(user, documents) &&
    isTermsNPValid(terms) &&
    !isExpiredDate()
  ) {
    return false;
  }

  if (
    isAuditor(user?.groups) &&
    isCarrierAudValid(carrier) &&
    isDocumentAudValid(user, documents)
  ) {
    return false;
  }
  return true;
};

export const handleCheckUniqueness = async ({
  state,
  user,
  dispatch,
  checkUniqueness,
}) => {
  let payload = {};

  const afm = user?.taxis_data?.afm;

  payload = {
    afm: afm,
  };

  const response = await dispatch(checkUniqueness(payload));
  return response;
};

export const handleThirdPartyValidations = async ({
  state,
  user,
  dispatch,
  thirdPartyValidations,
}) => {
  let payload = {};

  const afm = user?.taxis_data?.afm;

  payload = {
    afm: afm,
    phoneNumber: state?.carrier?.connNum || '',
    kad:
      isBeneficiary(user?.groups) && state?.carrier?.mainKAD
        ? state?.carrier?.mainKAD
        : '0',
    sorefsisAmount: state?.carrier?.totalAmountSorefsis,
    kaek: state?.carrier?.kaek || '0',
    isNp: isBeneficiary(user?.groups),
    procInstId: state?.task?.processInstanceId || '',
  };

  const response = await dispatch(thirdPartyValidations(payload));
  return response;
};

export const handleApproveAudit = async ({ taskId, dispatch }) => {
  const response = await dispatch(approveAudit(taskId));
  return response;
};

export const handleRejectAudit = async ({ payload, dispatch }) => {
  const response = await dispatch(rejectAudit(payload));
  return response;
};

export const handleApproveObjection = async ({ taskId, dispatch }) => {
  const response = await dispatch(approveObjection(taskId));
  return response;
};

export const handleRejectObjection = async ({ payload, dispatch }) => {
  const response = await dispatch(rejectObjection(payload));
  return response;
};

export const validEmail = email => {
  var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  var valid = false;
  if (email != null && email.match(mailformat)) {
    valid = true;
  }
  return valid;
};

export const validEmailNotMandatory = email => {
  if (isEmpty(email)) {
    return true;
  }
  var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  var valid = false;
  if (email != null && email.match(mailformat)) {
    valid = true;
  }
  return valid;
};

export const validDateStart = value => {
  const formattedValue = isString(value) ? moment(value) : value;
  let valid = true;

  if (value) {
    if (formattedValue.isBefore(new Date(new Date().valueOf()))) {
      valid = false;
    }
  } else {
    valid = false;
  }

  return valid;
};

export const validWebSite = website => {
  var valid = false;

  if (isEmpty(website)) {
    return true;
  }
  var webFormat = new RegExp(
    '^(https?:\\/\\/)?' + // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
      '(\\#[-a-z\\d_]*)?$',
    'i'
  ); // fragment locator
  if (website != null && website.match(webFormat)) {
    valid = true;
  }
  return valid;
};

export const validTk = tk => {
  var valid = false;

  if (!isNil(tk) && tk.length !== 5) {
    valid = false;
  } else {
    valid = true;
  }

  return valid;
};

export const validateTk = tk => {
  var valid = false;

  if (tk.length !== 5) {
    valid = false;
  } else {
    valid = true;
  }
  return valid
    ? Promise.resolve()
    : Promise.reject('Ο Τ.Κ θα πρέπει να είναι 5 ψηφία.');
};

export const validAbiGcrCode = (abiGcrCode, companyLegalType) => {
  var valid = false;

  if (!abiGcrCode && companyLegalType === 'Ατομική') {
    valid = true;
  } else {
    if (abiGcrCode.length !== 12 || abiGcrCode === '0'.repeat(12)) {
      valid = false;
    } else if (isNaN(abiGcrCode)) {
      valid = false;
    } else {
      valid = true;
    }
  }

  return valid;
};

export const validPartPercentage = Partper => {
  var valid = true;

  if (Partper > 100) {
    valid = false;

    return valid;
  }

  return valid;
};

export const validateTextAreaLength = (ta, maxLength) => {
  var valid = false;

  if (ta && ta.toString().length > maxLength) {
    return Promise.reject(
      'Έχετε φτάσει το μέγιστο επιτρεπτό όριο χαρακτήρων για αυτό το πεδίο'
    );
  } else {
    valid = true;
  }

  return valid
    ? Promise.resolve()
    : Promise.reject(
        'Έχετε υπερβεί το μέγιστο επιτρεπτό όριο χαρακτήρων για αυτό το πεδίο'
      );
};

export const validAFM = afm => {
  if (afm && afm.length !== 9) {
    // "Τα ψηφία του ΑΦΜ πρέπει να είναι 9 αριθμοί"
    return false;
  }

  if (!/^\d+$/.test(afm)) {
    // "Αυτό που εισάγετε δεν είναι αριθμός"
    return false;
  }

  if (afm === '0'.repeat(9)) {
    // "Αυτό που εισάγετε είναι μηδενικός αριθμός (000000000)"
    return false;
  }

  const sum = afm
    .substring(0, 8)
    .split('')
    .reduce((s, v, i) => s + (parseInt(v) << (8 - i)), 0);

  const calc = sum % 11;
  const d9 = parseInt(afm[8]);
  const valid = calc % 10 === d9;

  return valid;
};

export const validPhoneNumber = phone => {
  var phoneFormat = new RegExp(/^[0-9\b]+$/);
  if (!/^\d+$/.test(phone)) {
    // "Αυτό που εισάγετε δεν είναι αριθμός"
    return false;
  }
  if ((phone[0] !== '6' || phone[1] !== '9') && phone[0] !== '2') {
    return false;
  }

  if (phone.length !== 10) {
    return false;
  }
  if (phone != null && phone.match(phoneFormat)) {
    return true;
  }
};

export const validateMonth = month => {
  var valid = true;

  if (month < 1) {
    valid = false;

    return valid;
  }
  //console.log('valid einai :', valid);
  return valid
    ? Promise.resolve()
    : Promise.reject('Τα έτος ίδρυσης που εισάγατε δεν είναι έγκυρο');
};

export const sizeValid = (field, rule) => {
  if (field && field.length <= rule) {
    return true;
  }
  return false;
};

export const valueValid = (field, rule) => {
  if (field >= 0 && field <= rule) {
    return true;
  }
  return false;
};

export const percentageValid = field => {
  if (field >= -1 && field <= 1) {
    return true;
  }
  return false;
};

export const validated = formValidity => {
  if (formValidity) {
    return Object.keys(formValidity).filter(
      key => !(formValidity[key] === false)
    );
  }
  return true;
};

export const handleProjectPlanInfo = async ({
  state,
  dispatch,
  getProjectPlanInfo,
}) => {
  const businessPlanDetails = { ...state.businessPlanDetails };
  const resexpensestails = { ...state.resexpensestails };

  const response = await dispatch(
    getProjectPlanInfo(
      businessPlanDetails.abiVat,
      resexpensestails.investmentPlanElements.addedSchema
    )
  );
  return response;
};

export const validΤurnoverNm = value => {
  var valid = false;
  if (value < 0 || isNil(value) || isNaN(value)) {
    valid = false;
  } else {
    valid = true;
  }
  return valid;
};

export const validAnnualBalanceNm = value => {
  var valid = false;
  if (value < 0 || isNil(value) || isNaN(value)) {
    valid = false;
  } else {
    valid = true;
  }
  return valid;
};

export const validEmployeesNm = value => {
  var valid = false;
  const newValue = value
    ? parseFloat(value.toString().replaceAll(',', '.'))
    : null;

  if (newValue > 250) {
    valid = false;
  } else if (value < 0) {
    valid = false;
  } else if (isNil(newValue) || isNaN(newValue)) {
    valid = false;
  } else {
    valid = true;
  }

  return valid;
};

export const validSumPercentage = per => {
  var valid = true;

  if (per > 100) {
    valid = false;

    return Promise.reject('Τα ποσοστό που εισάγατε είναι μεγαλύτερο του 100%');
  } else if (per < 0) {
    valid = false;

    return Promise.reject('Τα ποσοστό που εισάγατε είναι αρνητικό');
  } else if (per == 0) {
    return Promise.reject(
      'Τα ποσοστό που εισάγατε πρέπει να είναι μεγαλύτερο του 0.'
    );
  }

  return valid
    ? Promise.resolve()
    : Promise.reject('Τα ποσοστό που εισάγατε δεν είναι έγκυρο');
};

export const validatePartPercentage = Partper => {
  var valid = true;

  if (Partper > 100) {
    valid = false;

    return Promise.reject('Τα ποσοστό που εισάγατε είναι μεγαλύτερο του 100%');
  } else if (Partper < 0) {
    valid = false;

    return Promise.reject('Τα ποσοστό που εισάγατε είναι αρνητικό');
  } else if (Partper == 0) {
    return Promise.reject(
      'Τα ποσοστό που εισάγατε πρέπει να είναι μεγαλύτερο του 0.'
    );
  }

  return valid
    ? Promise.resolve()
    : Promise.reject('Τα ποσοστό που εισάγατε δεν είναι έγκυρο');
};

export const validYear = year => {
  var valid = true;

  if (year === null) {
    valid = false;
  } else {
    if (year < 0) {
      valid = false;
    } else if (year.toString().length !== 4) {
      valid = false;
    } else {
      valid = true;
    }
  }

  return valid;
};

export const validateYear = year => {
  var valid = true;

  if (year === null) {
    valid = false;
  } else {
    if (year < 0) {
      valid = false;
      return Promise.reject('Τo Έτος Ίδρυσης πρέπει να είναι 4 ψηφία');
    } else if (year.toString().length !== 4) {
      valid = false;
    } else {
      valid = true;
    }
  }

  return valid
    ? Promise.resolve()
    : Promise.reject('Αυτό που εισάγετε δεν είναι έγκυρο Έτος Ίδρυσης');
};

export const validateMinLength = value => {
  var valid = true;
  const valueLength = value.toString().length;
  if (valueLength < 3) {
    valid = false;
    return Promise.reject('Ελάχιστοι χαρακτήρες 3.');
  }

  return valid
    ? Promise.resolve()
    : Promise.reject('Τα έτος ίδρυσης που εισάγατε δεν είναι έγκυρο');
};

export const validateAFM = afm => {
  if (afm.length !== 9) {
    // "Τα ψηφία του ΑΦΜ πρέπει να είναι 9 αριθμοί"
    return Promise.reject('Τα ψηφία του Α.Φ.Μ. πρέπει να είναι 9 αριθμοί');
  }

  if (!/^\d+$/.test(afm)) {
    // "Αυτό που εισάγετε δεν είναι αριθμός"
    return Promise.reject('Αυτό που εισάγετε δεν είναι αριθμός');
  }

  if (afm === '0'.repeat(9)) {
    // "Αυτό που εισάγετε είναι μηδενικός αριθμός (000000000)"
    return Promise.reject('Αυτό που εισάγετε δεν είναι έγκυρο Α.Φ.Μ.');
  }
  const sum = afm
    .substring(0, 8)
    .split('')
    .reduce((s, v, i) => s + (parseInt(v) << (8 - i)), 0);

  const calc = sum % 11;
  const d9 = parseInt(afm[8]);
  const valid = calc % 10 === d9;

  return valid
    ? Promise.resolve()
    : Promise.reject('Αυτό που εισάγετε δεν είναι έγκυρο Α.Φ.Μ.');
};

export const validateUserAFM = afm => {
  if (afm.length !== 9) {
    // "Τα ψηφία του ΑΦΜ πρέπει να είναι 9 αριθμοί"
    return 'Τα ψηφία του Α.Φ.Μ. πρέπει να είναι 9 αριθμοί';
  }

  if (!/^\d+$/.test(afm)) {
    // "Αυτό που εισάγετε δεν είναι αριθμός"
    return 'Αυτό που εισάγετε δεν είναι αριθμός';
  }

  if (afm === '0'.repeat(9)) {
    // "Αυτό που εισάγετε είναι μηδενικός αριθμός (000000000)"
    return 'Αυτό που εισάγετε δεν είναι έγκυρο Α.Φ.Μ.';
  }
  const sum = afm
    .substring(0, 8)
    .split('')
    .reduce((s, v, i) => s + (parseInt(v) << (8 - i)), 0);

  const calc = sum % 11;
  const d9 = parseInt(afm[8]);
  const valid = calc % 10 === d9;

  return valid ? '' : 'Αυτό που εισάγετε δεν είναι έγκυρο Α.Φ.Μ.';
};
// website validator

// export const validateWebSite = debounce((_, website) => {
//   var siteformat = /^(https?:\/\/)?((([a-z\d]([a-z\d-]*[a-z\d])*)\.)+[a-z]{2,}|((\d{1,3}\.){3}\d{1,3}))(\:\d+)?(\/[-a-z\d%_.~+]*)*(\?[;&a-z\d%_.~+=-]*)?(\#[-a-z\d_]*)?$/i;
//   var valid = false;
//   if (website != null && website.match(siteformat)) {
//     valid = true;
//   }
//   return valid
//     ? Promise.resolve()
//     : Promise.reject('Αυτό που εισάγετε δεν είναι έγκυρος ιστοχώρος');
// }, 300);

export const validateWebSite = debounce((rule, value, callback) => {
  const siteformat =
    /^(https?:\/\/)?((([a-z\d]([a-z\d-]*[a-z\d])*)\.)+[a-z]{2,}|((\d{1,3}\.){3}\d{1,3}))(\:\d+)?(\/[-a-z\d%_.~+]*)*(\?[;&a-z\d%_.~+=-]*)?(\#[-a-z\d_]*)?$/i;

  if (!value || siteformat.test(value)) {
    callback();
  } else {
    callback('Αυτό που εισάγετε δεν είναι έγκυρος ιστοχώρος');
  }
}, 300);

//Phone Number Validator
export const validatePhoneNumber = (
  phone,
  onlyMobile = false,
  mandatory = true
) => {
  var valid = false;

  if (!mandatory && (isNil(phone) || phone == '')) return Promise.resolve();
  var phoneFormat = new RegExp(/^[0-9\b]+$/);
  if (!/^\d+$/.test(phone)) {
    // "Αυτό που εισάγετε δεν είναι αριθμός"
    return Promise.reject('Αυτό που εισάγετε δεν είναι αριθμός');
  }
  if ((phone[0] !== '6' || phone[1] !== '9') && phone[0] !== '2') {
    return Promise.reject(
      'Αυτό που εισάγετε δεν είναι έγκυρος αριθμός τηλεφώνου'
    );
  }

  if (onlyMobile && (phone[0] !== '6' || phone[1] !== '9')) {
    return Promise.reject(
      'Αυτό που εισάγετε δεν είναι έγκυρος αριθμός κινητού τηλεφώνου'
    );
  }

  if (phone.length !== 10) {
    return Promise.reject('Τα ψηφία του τηλεφώνου πρέπει να είναι 10 αριθμοί');
  }
  if (phone != null && phone.match(phoneFormat)) {
    valid = true;
  }
  return valid
    ? Promise.resolve()
    : Promise.reject('Αυτό που εισάγετε δεν είναι έγκυρος αριθμός τηλεφώνου');
};
//todo test validator
export const validateEmail = debounce((_, email) => {
  var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  var valid = false;
  if (email != null && email.match(mailformat)) {
    valid = true;
  }
  return valid
    ? Promise.resolve()
    : Promise.reject('Αυτό που εισάγετε δεν είναι έγκυρο email');
}, 300);

export const validateEmailNotMandatory = debounce((_, email) => {
  if (!email || email.trim() === '') {
    return Promise.resolve();
  }

  const mailformat = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;

  if (mailformat.test(email)) {
    return Promise.resolve();
  } else {
    return Promise.reject('Αυτό που εισάγετε δεν είναι έγκυρο email');
  }
}, 300);

export const validateTkLength = tk => {
  var valid = false;

  if (tk.toString().length !== 5) {
    return Promise.reject('Τα ψηφία του ΤΚ πρέπει να είναι 5 αριθμοί');
  } else {
    valid = true;
  }

  return valid
    ? Promise.resolve()
    : Promise.reject('Αυτό που εισάγετε δεν είναι έγκυρος ΤΚ');
};

export const validateTkType = tk => {
  var valid = false;

  if (tk.typeof(tk) !== 'number') {
    return Promise.reject('Πληκτρολογήστε αριθμό');
  } else {
    valid = true;
  }

  return valid
    ? Promise.resolve()
    : Promise.reject('Αυτό που εισάγετε δεν είναι έγκυρος ΤΚ');
};

export const formattedNumber = (value = 0) => {
  let parts = value.toString().split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  // this check is enchanced for showing 2 decimals when the input has only one decimal. (e.g 5.7 will be converted to 5.70)
  // in case of multiple digits int decimal part of number round only the first two
  parts[1] =
    parts.length === 1
      ? '00'
      : Math.round(
          parseFloat(parts[1]) / 10 ** (parts[1].length - 2)
        ).toString();
  return parts.join(',');
};

export const currencyFormatter = (value = 0) => {
  return new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR',
  }).format(value);
};

export const percentageFormatter = (value = 0) => {
  //console.log(value);
  if (isNil(value) || isNaN(value)) {
    return '0,00%';
  }
  const simpleFormat = new Intl.NumberFormat('de-DE', {
    style: 'percent',
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  });
  let perc = simpleFormat.format(value / 100);
  return perc;
};

export const formattedPercentage = (value = 0) => {
  return formattedNumber(value * 100);
};

export const formattedValuesForShareHolders = values => {
  var formValues = cloneDeep(values);

  formValues.shareHolders &&
    formValues.shareHolders.map(
      item => (item.percentage = formattedPercentage(item.percentage))
    );

  return formValues;
};

export const filterGakPaidCategory = (value = '') => {
  if (value === 'Σύνολο') {
    return 'Σύνολο';
  }

  let info =
    !isEmpty(value) && value !== 'Μη ενισχυόμενη δαπάνη'
      ? exportGakCategory(value)
      : 'Μη αντιστοίχιση με ΓΑΚ';
  return info;
};

export const exportGakCategory = (value = '') => {
  //receives gak category and return trimmed string between parentheses, replacing certain words with '.'
  let trimmed = replace(value, '[', '(');
  trimmed = trimmed.substring(trimmed.indexOf('(') + 1, trimmed.indexOf(')'));
  trimmed = replace(trimmed, / παράγραφος | στοιχείο /g, '.');
  return capitalize(trimmed);
};

export const numberInputFormatter = value => {
  if (value) return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return;
};

export const numberInputParser = value => {
  if (value) return value.replace(/\./g, '');
  return;
};

export const toFixedWithoutRounding = number => {
  // receives a float number and keeps only 2 decimals.
  if (number) {
    // notice: the function has been modified to use round() and not floor()
    const value = (Math.round(toNumber(number) * 100) / 100).toFixed(2);
    const parsed = value.split('.');
    // replaced dot with comma
    return parsed[1] === '00' ? parsed[0] : value.replace('.', ',');
  }
  return;
};

export const hasReturnedToInvestor = status => {
  if (
    status === 'AS_2C1' || // Επιστροφή στο Φορέα Επένδυσης
    status === 'AS_3C1' || // Επιστροφή στο Φορέα της Επένδυσης
    status === 'AS_4C1' // Επιστροφή στο Φορέα Επένδυσης
  ) {
    return true;
  }
  return false;
};

export const isFinalStatus = status => {
  if (
    status === 'AS_3C' ||
    status === 'AS_3B2' // Ενταξη στο Μητρωο Εγκαταστατων
  ) {
    return true;
  }
  return false;
};

export const isRejectedStatus = status => {
  if (
    status === 'AS_2B1' // Ενταξη στο Μητρωο Εγκαταστατων
  ) {
    return true;
  }
  return false;
};

export const isRejectEvaluationStatus = status => {
  if (
    status === 'AS_2C' // Ενταξη στο Μητρωο Εγκαταστατων
  ) {
    return true;
  }
  return false;
};

export const validateDateCompletion = value => {
  const formattedValue = isString(value) ? moment(value) : value;
  let valid = true;

  if (formattedValue.isAfter('2027-01-01')) {
    valid = false;
  }

  return valid
    ? Promise.resolve()
    : Promise.reject(
        'Η εκτιμώμενη ημερομηνία ολοκλήρωσης του ΕΣ χρειάζεται να ειναι έως το 2026'
      );
};

export const validateDateCompletionAfterStart = (value, state) => {
  const formattedValue = isString(value) ? moment(value) : value;
  let valid = true;

  if (formattedValue.isBefore('2022-05-24')) {
    valid = false;
  }

  return valid
    ? Promise.resolve()
    : Promise.reject(
        'Η «Ημ. Έναρξης» να μην είναι μεταγενέστερη της «Ημ. Ολοκλήρωσης». '
      );
};

export function checkDateAfter(value, value_2) {
  var checkDate = new Date(value);
  checkDate.setDate(checkDate.getDate() + 1);
  if (!value_2.isAfter(checkDate)) {
    return true;
  } else {
    return false;
  }
}

export const validateDateStart = value => {
  const formattedValue = isString(value) ? moment(value) : value;
  let valid = true;

  if (
    formattedValue.isBefore(
      new Date(new Date().valueOf())
      //new Date(new Date().valueOf() - 1000 * 60 * 60 * 24)
    )
  ) {
    valid = false;
  }

  return valid
    ? Promise.resolve()
    : Promise.reject(
        'Η ημερομηνία έναρξης του ΕΣ χρειάζεται να ειναι μεγαλύτερη απο την σημερινή'
      );
};

export const getFullIsoDate = date => {
  if (date && moment(date).isValid()) {
    return moment(date).utc().format('DD/MM/YYYY HH:mm:ss');
  }
};

export const disabledDate = current => {
  return current && current < moment();
};

export const validateCompliance = checked => {
  let valid = true;

  if (!checked) {
    valid = false;
  }

  return valid
    ? Promise.resolve()
    : Promise.reject(
        <div className="ComplianceErrorMessage">Το πεδίο είναι υποχρεωτικό</div>
      );
};

export const validateRationale = rationale => {
  var rationaleformat = new RegExp(/^[a-zA-Z0-9-/?:().,'+ ]+$/);
  var valid = false;
  if (
    rationale != null &&
    rationale.match(rationaleformat) &&
    !isEmpty(rationale.trim())
  ) {
    valid = true;
  }
  return valid
    ? Promise.resolve()
    : Promise.reject(
        "Το μήκος του πεδίου δεν πρέπει να ξεπερνά τους 120 χαρακτήρες. Επιτρεπόμενοι χαρακτήρες: Κεφαλαία Λατινικά γράμματα (A-Z),Μικρά Λατινικά γράμματα (a-z), Αριθμοί (0-9) και οι παρακάτω ειδικοί χαρακτήρες Μικρά Λατινικά γράμματα (a-z), Αριθμοί (0-9) και οι παρακάτω ειδικοί χαρακτήρες / - ? : ( ) . , ' + Space "
      );
};

export const isvalidRationale = rationale => {
  var rationaleformat = new RegExp(/^[a-zA-Z0-9-/?:().,'+ ]+$/);
  var valid = false;
  if (
    rationale != null &&
    rationale.match(rationaleformat) &&
    !isEmpty(rationale.trim())
  ) {
    valid = true;
    return valid;
  } else return valid;
};

export const maskIBAN = info => {
  if (typeof info === 'undefined' || info === null || info.length === 0) {
    return '-';
  } else {
    return (
      info.substr(0, 2) +
      info.substr(2, 22).replace(/./g, '*') +
      info.substr(23, 4)
    );
  }
};

export const readUrlParams = () => {
  return Object.fromEntries(
    new URLSearchParams(window.location.hash.replace(/.*\?/, '')).entries()
  );
};

const messageCodeMap = {
  forgotPass:
    'Εάν η διεύθυνση email σας υπάρχει στη βάση δεδομένων μας, θα λάβετε έναν σύνδεσμο ανάκτησης κωδικού πρόσβασης στη διεύθυνση email με περαιτέρω οδηγίες.',
  invalidOperation: 'Η συγκεκριμένη ενέργεια δεν είναι έγκυρη πλέον.',
};

export const resolveMessageCode = code => {
  if (messageCodeMap[code]) return messageCodeMap[code];
  else return '';
};

export const schoolGrades = [
  { label: 'Παιδικός Σταθμός (Φοίβος)', value: 'Παιδικός Σταθμός' },
  { label: 'Βρεφονηπιακός (Φοίβος)', value: 'Βρεφονηπιακός' },
  { label: 'Βρεφικός (Φοίβος)', value: 'Βρεφικός' },
  { label: 'Νηπιαγωγείο (Αθηνά)', value: 'Νηπιαγωγείο' },
  { label: 'Δημοτικό Σχολείο (Αθηνά)', value: 'Δημοτικό Σχολείο' },
];
